/**
 * created by lei lei
 * 情感分析折线
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from "echarts-for-react";
import {Icon, Row, Col, Button} from "antd";
import CustomTable from '../customTable/CustomTable'
import {Scrollbars} from "react-custom-scrollbars";
import * as Utils from "../../../utils";

let option1 = {
    title: {
        // text: '单位：篇',//头部文字显示
        left: 50,
        top: 23,
        textStyle: {
            fontSize: '12',
            fontFamily: 'Microsoft YaHei'
        }
    },
    tooltip: {
        trigger: 'axis',
        show: true,// 必须引入 tooltip 组件,
    },
    legend: {
        // bottom: 0,//提示定位
        left: 'center',
        top: 20,
        show: true,
        /* data: ['已发派', '已提交', '已完成', '进行中']*/
    },
    grid: {
        left: '3%',
        right: '6%',
        bottom: '8%',
        containLabel: true
    },
    toolbox: {
        show: true,
        showTitle: false,
        feature: {}
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value',
        //max:100
        // minInterval : 1,
        // boundaryGap : [ 0, 0.3 ],
    },
    series: [
        /*{
            name: '已发派',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#BFBFBF',
                    lineStyle:{
                        color:'#BFBFBF'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },

       */

    ]
};
let option2 = {
    title: {
        /*   text: '某站点用户访问来源',
           subtext: '纯属虚构',*/
        left: 'center'
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    legend: {
        left: 'center',
        bottom: 20,
    },
    series: [
        {
            name: '分析数据',
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            data: [
                /*{value: 335, name: '正面'},
                {value: 310, name: '负面'},
                {value: 234, name: '中性'},*/
            ],
            itemStyle: {
                emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                normal: {
                    color: function (params) {
                        //自定义颜色
                        var colorList = [
                            '#00FFFF', '#00FF00', '#FFFF00', '#FF8C00', '#FF0000', '#FE8463',
                        ];
                        return colorList[params.dataIndex]
                    }
                }
            },
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};
let option3 = {
    title: {
        text: '单位：%',//头部文字显示
        left: 50,
        top: 23,
        textStyle: {
            fontSize: '12',
            fontFamily: 'Microsoft YaHei'
        }
    },
    tooltip: {
        trigger: 'axis',
        show: true,// 必须引入 tooltip 组件,
    },
    legend: {
        // bottom: 0,//提示定位
        left: 'center',
        top: 20,
        show: true,
        /* data: ['已发派', '已提交', '已完成', '进行中']*/
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '8%',
        containLabel: true
    },
    toolbox: {
        show: true,
        showTitle: false,
        feature: {}
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value',
        //max:100
        // minInterval : 1,
        // boundaryGap : [ 0, 0.3 ],
    },
    series: [
        /*{
            name: '已发派',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#BFBFBF',
                    lineStyle:{
                        color:'#BFBFBF'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },

       */

    ]
};
export default class BrokenLineAnalysis extends Component {
    static defaultProps = {
        height: 340,
        type: 'line'
    };
    static propTypes = {
        option: PropTypes.object.isRequired,//图表的数据来源这个是必须属性，但是加了会报错，数据必须传递
        height: PropTypes.number,//设置折线图的高度,选传
        dataSource: PropTypes.array.isRequired,//表格数据源必传项
        titleKeyList: PropTypes.array.isRequired,//表格列名称必传项
        type:PropTypes.string,//设置图表的类型：'line'。默认折线图，‘pie’，//饼状图，自定义类型
    };

    constructor(props) {
        super(props);
        this.state = {
            colorList: ['#FFBF00', '#00A854', '#0E77D1', 'pink', 'green', 'red', 'blue', 'yellow', 'gray'],
            showTable: false,//展示表格的状态，默认false,true时候 展示
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    hideTable(){
        this.setState({
            showTable:false
        })
    }

    render() {

        let option;
        //圆饼状和折线图
        if (this.props.type === 'pie') {
            option2.series[0].data=[];
            option2.series[0].data = this.props.option.data;//赋值数据
            let that=this;
            //赋值颜色
            option2.series[0].itemStyle.normal= {
                color: function (params) {
                    //自定义颜色
                    var colorList = that.props.option.colorList;
                    return colorList[params.dataIndex]
                }
            };
            option = option2
        } else  if (this.props.type === 'line1') {
            option1.xAxis.data = this.props.option.xData;//赋值X周数据
            let colorList = this.props.option.colorList ? this.props.option.colorList : this.state.colorList;//赋值颜色
            option1.series = [];
            //赋值y轴数据
            this.props.option.yData.forEach((item, i) => {
                option1.series.push(
                    {
                        name: '',
                        type: 'line',
                        /* stack: '总量',*/
                        itemStyle: {
                            normal: {
                                color: colorList[i],
                                lineStyle: {
                                    color: colorList[i]
                                }
                            }
                        },
                        data: [],
                        ...item
                    }
                )
            });
            option = option1
        }else  if (this.props.type === 'line2') {
            option3.xAxis.data = this.props.option.xData;//赋值X周数据
            let colorList = this.props.option.colorList ? this.props.option.colorList : this.state.colorList;//赋值颜色
            option3.series = [];
            //赋值y轴数据
            this.props.option.yData.forEach((item, i) => {
                option3.series.push(
                    {
                        name: '',
                        type: 'line',
                        /* stack: '总量',*/
                        itemStyle: {
                            normal: {
                                color: colorList[i],
                                lineStyle: {
                                    color: colorList[i]
                                }
                            }
                        },
                        data: [],
                        ...item
                    }
                )
            });
            option = option3
        }

        return (
            <div style={{width: '100%', position: 'relative'}}>
                {
                    this.state.showTable ? <div style={{position: 'relative'}}>
                            <div style={{display: 'flex'}}>
                                <div style={{width: '10%'}}>
                                    <div style={{width: 20, margin: 'auto', marginTop: 20}}>数据视图</div>
                                </div>
                                <div style={{width: '80%', height: this.props.height}}>
                                    <Scrollbars>
                                        <CustomTable
                                            dataSource={this.props.dataSource}
                                            titleKeyList={this.props.titleKeyList}
                                            pagination={false}
                                        />
                                    </Scrollbars>
                                </div>
                                <div style={{width: '10%'}}>
                                    <Button style={{position: 'absolute', bottom: 20}} type="danger" onClick={() => {
                                        this.setState({showTable: false})
                                    }}>关闭</Button>
                                </div>
                            </div>
                        </div> :
                        <div style={{position: 'relative', height: this.props.height,}}>
                            <div style={{
                                width: 30,
                                textAlign: 'center',
                                position: 'absolute',
                                right: 50,
                                top: 20,
                                cursor: 'pointer',
                                zIndex: 1000
                            }} onClick={() => {
                                this.setState({showTable: true})
                            }} title={'查看数据'}>
                                <Icon style={{fontSize: 20}} type="profile"/>
                            </div>

                            <ReactEcharts
                                key={Utils.uuid()}
                                option={option}
                                notMerge={true}
                                lazyUpdate={true}
                                style={{width: '100%', height: '100%'}}
                            />
                        </div>
                }
            </div>
        )
    }

}